
export default function SurveyMCQQuestion({ item, value, onChange }) {
  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex flex-col gap-2 items-start">
        {item.options?.map((opt, idx) => (
          <label
            key={idx}
            className="flex items-center gap-2 text-sm text-slate-700"
          >
            <input
              type="radio"
              name={`mcq-${item.itemid}`}
              value={opt}
              checked={value === opt}
              onChange={() => onChange(opt)}
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>
    </div>
  );
}